import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/tokens.css";

Vue.use(ElementUI, { size: "medium", locale });

// ApexCharts: registered globally as an async component so the library
// (~600 KB gz) ships in its own chunk and is fetched only when a tab renders
// its first <apexchart>.
Vue.component("apexchart", () => import("vue-apexcharts"));

window.Apex = {
  chart: {
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    toolbar: { show: false },
    zoom: { enabled: false },
    animations: { speed: 250 },
  },
  stroke: { curve: "smooth", width: 2 },
  grid: { borderColor: "rgba(15,23,42,0.06)", strokeDashArray: 3, padding: { left: 0, right: 0 } },
  dataLabels: { enabled: false },
  colors: ["#6366f1", "#0ea5e9", "#f59e0b", "#f43f5e", "#10b981", "#8b5cf6"],
  yaxis: { labels: { style: { colors: "#94a3b8", fontSize: "11px" } } },
  xaxis: { labels: { style: { colors: "#94a3b8", fontSize: "11px" } } },
  legend: { fontSize: "12px", labels: { colors: "#475569" } },
  tooltip: { theme: "light" },
};

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
